import axios from 'axios';
import { store } from '../store';

const API_URL = process.env.REACT_APP_API_URL || 'https://pelican-beaks-backend-350185136100.us-east1.run.app';

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
  maxRedirects: 5, // Allow redirects (default is 5)
});

// Add token to requests if it exists
api.interceptors.request.use((config) => {
  // First try localStorage
  let token = localStorage.getItem('token');
  
  // If not in localStorage, try Redux store as fallback
  if (!token) {
    const state = store.getState();
    token = state.auth?.token;
  }
  
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    console.log('API Request - Token added to headers:', token.substring(0, 20) + '...');
  } else {
    console.warn('API Request - No token found in localStorage or Redux store');
  }
  
  return config;
});

// Handle 401 Unauthorized globally
api.interceptors.response.use(
  response => response,
  error => {
    console.error('API Response Error:', {
      status: error.response?.status,
      message: error.response?.data?.message,
      url: error.config?.url,
      method: error.config?.method
    });
    
    if (error.response && error.response.status === 401) {
      // remove expired auth data
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      // redirect to login page
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth endpoints
export const register = (userData) => api.post('/auth/register', userData);
export const login = (credentials) => api.post('/auth/login', credentials);
export const getCurrentUser = () => api.get('/auth/me');
export const forgotPassword = (email) => api.post('/auth/forgot-password', { email });
export const resetPassword = (token, newPassword) => api.post('/auth/reset-password', { token, new_password: newPassword });

// Travel Plans endpoints
export const getTravelPlans = () => api.get('/travel-plans');
export const createTravelPlan = (planData) => api.post('/travel-plans', planData);
export const updateTravelPlan = (id, planData) => api.put(`/travel-plans/${id}`, planData);
export const deleteTravelPlan = (id) => api.delete(`/travel-plans/${id}`);
export const getTravelPlan = (id) => api.get(`/travel-plans/${id}`);
export const updateTravelPlanCoverImage = (id, imageUrl) => api.put(`/travel-plans/${id}`, { coverImageUrl: imageUrl });
export const uploadTravelPlanCoverImage = (id, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post(`/travel-plans/${id}/upload-cover`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};
export const likeTravelPlan = (id) => api.post(`/travel-plans/${id}/like`);
export const unlikeTravelPlan = (id) => api.post(`/travel-plans/${id}/unlike`);
export const copyTravelPlan = (id) => api.post(`/travel-plans/${id}/copy`);
export const searchTravelPlans = (params) => api.get('/travel-plans/search', { params });
export const getLikedTravelPlans = () => api.get('/travel-plans/liked');

// Events endpoints
export const addEvent = (planId, eventData) => api.post(`/travel-plans/${planId}/events`, eventData);
export const updateEvent = (planId, eventId, eventData) => api.put(`/travel-plans/${planId}/events/${eventId}`, eventData);
export const deleteEvent = (planId, eventId) => api.delete(`/travel-plans/${planId}/events/${eventId}`);

// AI Generation
export const generateTravelPlan = (promptData) => api.post('/travel-plans/generate-travel-plan', promptData);

// Subscription endpoints
export const createCheckoutSession = (priceId, userId) => 
  api.post('/create-checkout-session', { price_id: priceId, user_id: userId });

export const getSubscriptionDetails = () => 
  api.get('/subscription/details');

export const createPortalSession = () => 
  api.post('/create-portal-session');

export default api; 